import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Header, Paper } from '../components';
import { TextField } from '../components/TextField';
import Stack from '@mui/material/Stack';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useState } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Button from '../components/Button';
import { Typography } from '@mui/material';
import Link from '@mui/material/Link';
const LoginForm = () => {
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    // Handle keyboard events for better accessibility
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleClickShowPassword();
        }
    };
    return (_jsxs(Paper, { children: [_jsx(Header, Object.assign({ id: 'login-header' }, { children: "LOGGA IN PA MITT KONTO" })), _jsxs("form", Object.assign({ method: 'post', action: '/account/login', id: 'customer_login', acceptCharset: 'UTF-8', noValidate: true, "aria-labelledby": 'login-header' }, { children: [_jsxs(Stack, Object.assign({ spacing: 1.5 }, { children: [_jsx(TextField, { id: 'customer_email', label: 'E-post', name: 'customer[email]', autoComplete: 'email', required: true, "aria-required": 'true', inputProps: {
                                    'aria-label': 'E-post',
                                    'aria-describedby': 'email-description',
                                } }), _jsx("span", Object.assign({ id: 'email-description', className: 'visually-hidden' }, { children: "Ange din e-postadress f\u00F6r att logga in" })), _jsx(TextField, { id: 'customer_password', label: 'Losenord', name: 'customer[password]', autoComplete: 'current-password', type: showPassword ? 'text' : 'password', required: true, "aria-required": 'true', inputProps: {
                                    'aria-label': 'Lösenord',
                                    'aria-describedby': 'password-description',
                                }, endAdornment: _jsx(InputAdornment, Object.assign({ position: 'end' }, { children: _jsx(IconButton, Object.assign({ "aria-label": showPassword ? 'Dölj lösenord' : 'Visa lösenord', onClick: handleClickShowPassword, onMouseDown: handleMouseDownPassword, onKeyDown: handleKeyDown, edge: 'end' }, { children: showPassword ? _jsx(VisibilityOff, { "aria-hidden": 'true' }) : _jsx(Visibility, { "aria-hidden": 'true' }) })) })) }), _jsx("span", Object.assign({ id: 'password-description', className: 'visually-hidden' }, { children: "Ange ditt l\u00F6senord" })), _jsx(FormControlLabel, { control: _jsx(Checkbox, { id: 'customer_remember_me', name: 'customer[remember_me]', defaultChecked: true, sx: (theme) => {
                                        var _a, _b;
                                        return ({
                                            marginLeft: -1.5,
                                            color: (_a = theme.account) === null || _a === void 0 ? void 0 : _a.page.heading,
                                            '&.Mui-checked': {
                                                color: (_b = theme.account) === null || _b === void 0 ? void 0 : _b.page.heading,
                                            },
                                            borderWidth: '1px',
                                        });
                                    }, inputProps: {
                                        'aria-label': 'Förbli inloggad',
                                    } }), sx: {
                                    '& .MuiTypography-root': {
                                        color: '#000',
                                        fontSize: '12px',
                                        marginLeft: -0.5,
                                    },
                                }, label: 'Forbli inloggad' }), _jsx(Button, Object.assign({ type: 'submit', "aria-label": 'Logga in p\u00E5 mitt konto' }, { children: "LOGGA IN" })), _jsx(Typography, Object.assign({ variant: 'body2', sx: { textAlign: 'center', paddingTop: 1 } }, { children: _jsx(Link, Object.assign({ href: '/account/recover', sx: {
                                        color: '#000',
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        textDecoration: 'underline',
                                    }, "aria-label": '\u00C5terst\u00E4ll gl\u00F6mt l\u00F6senord' }, { children: _jsx("small", { children: "Glomt ditt losenord?" }) })) }))] })), _jsx("div", { "aria-live": 'assertive', role: 'alert', id: 'login-form-errors', style: {
                            position: 'absolute',
                            width: '1px',
                            height: '1px',
                            padding: '0',
                            margin: '-1px',
                            overflow: 'hidden',
                            clip: 'rect(0, 0, 0, 0)',
                            whiteSpace: 'nowrap',
                            borderWidth: '0',
                        } })] }))] }));
};
export default LoginForm;
